import type { ReactNode } from 'react';

/**
 * There is nothing here, and that is the answer rather than a failure.
 *
 * Distinguishing this from an error matters more than it looks: "nenhum
 * beneficiário nesta competência" and "não conseguimos carregar os
 * beneficiários" lead to completely different next actions, and a blank panel
 * says neither.
 */
export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="state state--empty">
      <p className="state__title">{title}</p>
      {description !== undefined && <p className="state__message">{description}</p>}
      {action !== undefined && <div className="state__action">{action}</div>}
    </div>
  );
}
